import { Injectable } from "@angular/core";
import { Store, select } from "@ngrx/store";
import {
  RoomBrandBgDeferredErrorVO,
  RoomBrandBgDeleteEventVO,
  RoomBrandBgSetEventVO,
  RoomBrandBgCreate1VO,
  RoomBrandBgCreate2VO,
  RoomBrandBgDeleteVO,
  RoomBrandBgUnUseVO,
  RoomBrandBgUseVO
} from "@youm-front/room/domain";
import { fileImageDimension } from "@youm-front/utils/image";
import { invalidImageFileMessage } from "./invalid-image-file-message";
import { RoomBrandBgActions } from "../actions";
import { RoomBrandBgEvents } from "../events";
import { RoomBrandBgSelectors } from "../selectors";
import { BrandBgDataHeight, BrandBgDataWidth } from "@common/domain";

@Injectable()
export class RoomBrandBgFacade {
  brandBg$ = this.store.pipe(select(RoomBrandBgSelectors.brandBg));
  isLoading$ = this.store.pipe(select(RoomBrandBgSelectors.isLoading));

  constructor(private readonly store: Store) {}

  roomBrandBgDeferredErrorEvent(
    roomBrandBgDeferredErrorVO: RoomBrandBgDeferredErrorVO
  ) {
    this.store.dispatch(
      RoomBrandBgEvents.roomBrandBgDeferredErrorEvent({
        roomBrandBgDeferredErrorVO
      })
    );
  }

  roomBrandBgDeleteEvent(roomBrandBgDeleteEventVO: RoomBrandBgDeleteEventVO) {
    this.store.dispatch(
      RoomBrandBgEvents.roomBrandBgDeleteEvent({
        roomBrandBgDeleteEventVO
      })
    );
  }

  roomBrandBgSetEvent(roomBrandBgSetEventVO: RoomBrandBgSetEventVO) {
    this.store.dispatch(
      RoomBrandBgEvents.roomBrandBgSetEvent({
        roomBrandBgSetEventVO
      })
    );
  }

  async roomBrandBgCreate(roomBrandBgCreate1VO: RoomBrandBgCreate1VO) {
    let dimension: { width: number; height: number };
    try {
      dimension = await fileImageDimension(roomBrandBgCreate1VO.value.data);
    } catch {
      this.store.dispatch(
        RoomBrandBgActions.roomBrandBgCreateFailure({
          error: invalidImageFileMessage()
        })
      );
      return;
    }
    const { width, height } = dimension;

    const roomBrandBgCreate2VO = new RoomBrandBgCreate2VO({
      brandId: roomBrandBgCreate1VO.value.brandId,
      data: roomBrandBgCreate1VO.value.data,
      roomId: roomBrandBgCreate1VO.value.roomId,
      width: width as BrandBgDataWidth,
      height: height as BrandBgDataHeight
    });

    this.store.dispatch(
      RoomBrandBgActions.roomBrandBgCreate({
        roomBrandBgCreateVO: roomBrandBgCreate2VO
      })
    );
  }

  roomBrandBgDelete(roomBrandBgDeleteVO: RoomBrandBgDeleteVO) {
    this.store.dispatch(
      RoomBrandBgActions.roomBrandBgDelete({
        roomBrandBgDeleteVO
      })
    );
  }

  roomBrandBgUnUse(roomBrandBgUnUseVO: RoomBrandBgUnUseVO) {
    this.store.dispatch(
      RoomBrandBgActions.roomBrandBgUnUse({
        roomBrandBgUnUseVO
      })
    );
  }

  roomBrandBgUse(roomBrandBgUseVO: RoomBrandBgUseVO) {
    this.store.dispatch(
      RoomBrandBgActions.roomBrandBgUse({
        roomBrandBgUseVO
      })
    );
  }
}
